import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { PinTableComponent } from "../../../pin-modules/pin-table-module/components/pin-table/pin-table.component";

import { SessionService } from "../../../../app/common/services/session.service";
import { UtilityService } from "../../../shared/utility.service";
import { VoterSearchAPIService } from "../../services/api/api.service";
import { GLOBAL_CONSTANT } from "src/app/common/constant/global.constant";
import { ApiService } from "src/app/service/api/api.service";
import * as fileSaver from "file-saver";
interface City {
  name: string;
  code: string;
}

@Component({
  selector: "app-voter-search-result-list",
  templateUrl: "./result-list.component.html",
  styleUrls: ["./result-list.component.scss"],
  // providers: [DialogService],
})
export class VoterSearchResultListComponent implements OnInit {
  searchResultListConfig: any;
  searchResultListRes: any = [];
  searchResp = [];
  selectedData: any;
  roleFlag: Boolean = false;
  selectedUsers: any;
  entityName: string = "profileImage";
  @ViewChild("instanceResultTable", { static: false })
  instanceResultTable: PinTableComponent;
  _data: any;
  assignKFlag: boolean = false;
  selectedVisitorToPrint: any = {};
  showPrint: boolean = true;
  @ViewChild("printContent", { static: false }) printContent: ElementRef;
  ratingValue: any = 3;
  editRateFlag: boolean = false;
  //ratingData: any;
  selectedRatingData:any;
  kalOptions: Array<any>; 
  searchFormModel: any;//IN_SearchByWild;

  @Input() lastNameListDataChanged;
  @Input() onSubMenuTriggered;
  @Input() showLeftSide

  cities: City[];

  selectedCity: City;

  countries: any[];

  selectedCountry: string;
  lastNameListData: any;
  lastNameListCount: any;
  value1: any;
  sharedData: any;

  @Input()
  get data(): any {
    return this._data;
  }
  set data(value: any) {
    this._data = value;
    this._onSearchFromStart();
  }
  @Input()
  get lastNameSelect(): any {
    return this._data;
  }
  set lastNameSelect(value: any) {
    this._data = value;
    this._onSearchFromStart();
  }

  @Output() afterSearchData = new EventEmitter();
  @Output() afterRowSelection = new EventEmitter();
  @Output() afterRowPrint = new EventEmitter();
  @Output() UpdatedLastname = new EventEmitter();

  constructor(
    private service: VoterSearchAPIService,
    private us: UtilityService,
    private ss: SessionService,
    private apiService : VoterSearchAPIService
  ) {
    this.selectedData = {};
    this.selectedRatingData = {};
    this.countries = [
      { name: "Australia", code: "AU" },
      { name: "Brazil", code: "BR" },
    ];
    this.kalOptions = GLOBAL_CONSTANT.KAL_OPTIONS; // add kal constant
    this._init()
  }


  getSearchResultListSearchViewConfig() {
    this.service.getSearchResultListSearchViewConfig().subscribe((res) => {
      this.searchResultListConfig = res;
    });
  }

  handleEvent(event) {
    if (event.name == "LAZY_LOAD") {
      this._data.page = this.us.PaginationPerPage(event.event);
      this._onSearchPagination();
    }
    if (event.name == "SELECT") {
      // this.afterRowSelection.emit({ data: event.data });
      this.selectedData = event.data;
    }
  }

  private _onSearchFromStart() {
    if (this.instanceResultTable) {
      this.instanceResultTable.reset();
    }
  }

  private _onSearchPagination() {
    this._onSearch();
  }

  private _onSearch() {
    this.selectedData = {};
    switch (this._data.type) {
      case undefined:
      case "DEFAULT":
        {
          this._data.type = "DEFAULT";
          this._onSearchByDefault(this._data);
        }
        break;
      case "BYNAME":
        {
          this._data.type = "BYNAME";
          this._onSearchByName(this._data);
        }
        break;
      case "BYAGE":
        {
          //this._onSearchByAge(this._data);
          this._data.type = "BYNAME";
          this._onSearchByName(this._data);
        }
        break;
      case "WILD":
        {
          //this._onSearchByWild(this._data);
          this._data.type = "BYNAME";
          this._onSearchByName(this._data);
        }
        break;

      case "BYLASTNAME":
        {
          //this._onSearchBySurname(this._data);
          this._data.type = "BYNAME";
          this._onSearchByName(this._data);
        }
        break;
      case "BYEDUCATION":
        {
          // this._onSearchByName(this._data);
          // this._onSearchByEdu(this._data);
          this._data.type = "BYNAME";
          this._onSearchByName(this._data);
        }
        break;
      case "VOTERID":
        {
          //this._onSearchByVoterId(this._data);
          this._data.type = "BYNAME";
          this._onSearchByName(this._data);
        }
        break;
      case "GENERAL":
        {
          //this._onSearchByGeneral(this._data);
          this._data.type = "BYNAME";
          this._onSearchByName(this._data);
        }
        break;
      case "PHONE":
        {
          //this._onSearchByPhone(this._data);
          this._data.type = "BYNAME";
          this._onSearchByName(this._data);
        }
        break;
      case "BYOCCUPATION":
        {
          //this._onSearchByOcc(this._data);
          this._data.type = "BYNAME";
          this._onSearchByName(this._data);
        }
        break;
    }
  }

  private _onSearchByDefault(payload) {
    this.service.searchByDefault(payload).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }

  private _onSearchByVoterId(searchByVoterId) {
    this.service.searchByVoterId(searchByVoterId).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }
  private _onSearchByPhone(searchByPhone) {
    this.service.searchByPhone(searchByPhone).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }

  private _onSearchByGeneral(searchByGeneral) {
    this.service.searchByGeneral(searchByGeneral).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }

  //NVSF
  private _onSearchByName(searchByName) {
    this.service.searchByName(searchByName).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }

  private _onDownloadExel(searchByName) {
    this.service.export(searchByName).subscribe(
      (resp: any) => {        
        var blob = new Blob([resp], { type: "text/plain;charset=utf-8" });
        fileSaver.saveAs(blob, "Complaint.csv");
  
      },
      (error) => {}
    );
  }

  private _onSearchByAlphabet(searchByAlphabet) {
    this.service.searchByAlphabet(searchByAlphabet).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }
  private _onSearchByAge(searchByAge) {
    this.service.searchByAge(searchByAge).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }

  private _onSearchByWild(searchByWild) {
    this.service.searchByWild(searchByWild).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }

  private _onSearchBySurname(searchBySurname) {
    //searchBySurname.type = "BYSURNAME";
    let d = JSON.parse(JSON.stringify(searchBySurname));
    d.type = "BYSURNAME";
    this.service.searchBySurname(d).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }
  private _onSearchByEdu(searchByEdu) {
    this.service.searchByEdu(searchByEdu).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }

  private _onSearchByOcc(searchByOcc) {
    this.service.searchByOcc(searchByOcc).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        this.afterSearchData.emit({
          data: JSON.parse(JSON.stringify(this.searchResp)),
        });
      },
      (error) => {}
    );
  }

  changeSelection(rowData) {
    this.selectedData = {};
  }

  editVoter(rowData) {
    this.afterRowSelection.emit({ data: rowData });
    this.selectedData = rowData;
  }

  printVoter(rowData) {
    this.selectedVisitorToPrint = rowData;
    this.afterRowPrint.emit({ data: rowData });
    this.showPrint = true;
    //send data to print html
    //send to print array for tab no 4 using api
  }

  print() {
    this.showPrint = false;
    const printContents = this.printContent.nativeElement.innerHTML;
    console.log(printContents);

    const popupWin = window.open(
      "",
      "_blank",
      "top=0,left=0,height=auto,width=auto"
    );
    popupWin.document.open();
    setTimeout(() => {
      popupWin.document.write(`
        <html>
          <head>
            <title>Print</title>
            <style>
              // Define your print styles here if needed
            </style>
          </head>
          <body onload="window.print();window.close()">${printContents}</body>
        </html>`);
      popupWin.document.close();
    }, 2000);
  }

  setRateData(rowData) {
    this.editRateFlag = true;
    this.selectedData = rowData;
    this.selectedRatingData = {id:rowData.id,rating:rowData.rating,votingKal:rowData.votingKal}
    // this.ratingValue = this.ratingData.VALUE;
  }

  updateRatingStatus(event, ratingData) {
    this.service.updateRecord(ratingData).subscribe((resp: any) => {
      this.selectedData.rating = ratingData.rating;
      this.selectedData.votingKal = ratingData.votingKal;
    });
  }

  ngOnInit() {
    this.getSearchResultListSearchViewConfig();
    let userInfo = this.ss.getUserInfo();
    if (userInfo && userInfo.role === "SUPER_ADMIN") {
      this.roleFlag = true;
    }
    this.cities = [
      { name: "New York", code: "NY" },
      { name: "Rome", code: "RM" },
      { name: "London", code: "LDN" },
      { name: "Istanbul", code: "IST" },
      { name: "Paris", code: "PRS" },
    ];

    // this.countries = [
    //   { name: 'Australia', code: 'AU' },
    //   { name: 'Brazil', code: 'BR' }
    // ];

    this.apiService.sharedData$.subscribe(data => {
      this.sharedData = data;
    });
  }
  private getLastNameList(searchText){
    this.service.initSurnameListData(searchText).subscribe((resp: any) => {
       this.lastNameListData = resp;
      //  console.log(this.lastNameListData);
       this.lastNameListCount = this.lastNameListData.length;
     });
   }

  
   updateLname(lastNameObj): void {
    this.searchFormModel.filters.lastName = lastNameObj.lastName;
    this.value1=this.searchFormModel.filters.lastName 
    this.apiService.updateSharedData(this.value1);
  }
  downloadExcel() {
    this._data.type = "BYNAME";
    this._onDownloadExel(this._data);
  }

  
  private _init() {
    this.getLastNameList('null');
    this.searchFormModel = {
      type: "BYNAME",
      filters: {},
      page: {
        number: 0,
        size: 10,
      },
    };
    this.selectedData = {};
  }
}
